<template>
  <v-container fluid class="pa-0">

    <v-row style="background-color:#fff;" no-gutters class="pl-10 pr-10">
      <v-col cols="6">
        <v-row no-gutters >
          <v-col cols="8" class="mr-0 mt-4 ">
            <v-btn class="mr-2" width="80" :dark="activeParamInfo==1" @click="activeParamInfo=1" :color="activeParamInfo==1?'#0057FF':'#fff'">运行参数</v-btn>
            <v-btn class="mr-2" width="80" :disabled="activeParamButton" :dark="activeParamInfo==2" @click="activeParamInfo=2" :color="activeParamInfo==2?'#0057FF':'#fff'">系统参数</v-btn>
            <v-btn class="mr-2" width="80" :disabled="activeParamButton" :dark="activeParamInfo==3" @click="activeParamInfo=3" :color="activeParamInfo==3?'#0057FF':'#fff'">运行日志</v-btn>
<!--            <v-btn class="mr-2" width="80" :dark="activeParamInfo==4" @click="activeParamInfo=4" :color="activeParamInfo==4?'#0057FF':'#fff'">运行分析</v-btn>-->
          </v-col>
          <v-col cols="4" class="mr-0">
            <!--上海市同仁医院-->
            <Z-Source-Selector label="医院"
                               itemText="hospName"
                               itemValue="id"
                               :initLoad="false"
                               :itemsList="hospList"
                               :clearable="false"
                               @changevalue="changeHosp"
                               v-model="currentHospId"></Z-Source-Selector>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6" class="flex-view-style j-c-s" style="font-size:0.88rem;">
        <div>
          <span style="color:#666;">入网设备：</span>
          <span style="color:#000;">{{currentHospEqpNum}}台</span>
        </div>
        <div class="flex-view-style j-c-f">
          <div class="flex-view-style j-c-f mr-6" v-if="activeParamInfo==1 && this.cardList.length != 0 && this.cardList[activeEqpCard].daqType!=null">
            <v-btn color="primary" @click="eqpLogReport">设备环境日志导出</v-btn>
          </div>
          <div class="flex-view-style j-c-f mr-6">
            <span class="divIcon"></span>
            正常
          </div>
          <div class="flex-view-style j-c-f">
            <span class="divIcon orange_divIcon"></span>
            预警
          </div>
        </div>
      </v-col>
    </v-row>

    <v-container fluid v-if="cardList.length>0" class="pl-10 pr-10">

      <v-carousel
          show-arrows-on-hover
          height="auto"
          :show-arrows="cardList.length>6?true:false"
          hide-delimiter-background
          hide-delimiters
      >
        <!--假如数据长度是6的整数，则滚动的页数刚好是长度除以6，否则是长度除以6+1-->
        <v-carousel-item
            v-for="(slide, index) in (cardList.length%6==0)?(cardList.length/6):(parseInt(cardList.length/6)+1)"
            :key="index"
        >

          <v-row align="stretch">
            <!--假如数据长度是6的整数且是最后一页，则最后一页的数据长度还是6否则是长度除以长度除以6的余数-->
            <v-col
                v-for="(item,key) in (index+1)==((cardList.length%6==0)?(cardList.length/6):(parseInt(cardList.length/6)+1))?(cardList.length%6==0?6:cardList.length%6):6"
                :key="key"
                cols="2">
              <v-hover
                  v-slot:default="{ hover }"
                  open-delay="200"
              >
                <v-card
                    :elevation="hover ? 6 : 2"
                    @click="clickCard(6,index,key)"
                    class="pa-2 fill-height"
                    :color="activeEqpCard==(index*6+key)?(cardList[index*6+key].isWarning?'#FF7E00':'#0057FF'):'#fff'"
                    :light="activeEqpCard==(index*6+key)?false:true"
                >
                  <div>
                    <div class="d-flex justify-space-between align-center">
                      <div>
                        <div class="font-weight-bold">{{cardList[(index*6)+key].businessName}}
                        </div>
                        <div class="f-s-14">{{cardList[(index*6)+key].eqpFactSerialNo}}</div>
                      </div>
                      <div :class="activeEqpCard==(index*6+key)?cardList[index*6+key].isWarning?'deptName activeWarningColor':'deptName activeColor':'deptName'">
                        {{cardList[(index*6)+key].parentName}}
                      </div>
                    </div>
                    <v-divider class="mt-2 mb-2"></v-divider>
                    <div class="f-s-14 d-flex justify-space-between align-center">
                      <div>{{cardList[(index*6)+key].eqpBrand}}</div>
                      <div>{{cardList[(index*6)+key].eqpModel}}</div>
                      <div class="warningIcon"
                           :style="{visibility:!cardList[(index*6)+key].isWarning?'hidden':'visible'}">
                        <img src="@/assets/yujing@2x.png"
                             style="width:0.875rem;" alt="">
                        预警
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>

        </v-carousel-item>
      </v-carousel>

      <!--    设备日志信息图标        -->
      <v-row v-if="activeParamInfo==1 ">
        <!--todo:运行参数图表信息处理 -->
        <v-col cols="4"
               v-for="(item,index) in eqpLogList"
               :key="index">
          <v-hover
              v-slot:default="{ hover }"
              open-delay="200"
          >
            <v-card
                :elevation="hover ? 6 : 0"
                class="pa-2 fill-height"
                color
                light
            >
              <div class="d-flex justify-space-between align-center">
                <div class="d-flex align-center">
                  <span class="font-weight-black">{{ item.logColumnDesc }}</span>
                  <span style="color:#666;font-size:0.875rem;">(
                    <!--预警规则 01大于 02小于 03等于 04不等于，展示取反-->
                                        <span v-if="item.warnRule=='01'"><=</span>
                                        <span v-if="item.warnRule=='02'">>=</span>
                                        <span v-if="item.warnRule=='03'">≠</span>
                                        <span v-if="item.warnRule=='04'">=</span>
                                        {{ item.collectDataType == '05' ? (item.warnValue == '1.0' ? '开' : '关') : item.warnValue }}
                                        <span v-if="item.collectDataType!='05'">{{ item.unit }}</span>)</span>
                </div>
                <div :class="item.isWarning?'currentNum warningCurrentNum':'currentNum'"
                     v-if="item.dataList.length>0">
                  {{ item.collectDataType == '05' ? (item.dataList.length > 0 ? (item.dataList[item.dataList.length - 1].value == 1 ? '开' : '关') : '') : (item.dataList.length > 0 ? item.dataList[item.dataList.length - 1].value : '') }}
                  <span>{{ item.unit }}</span>
                </div>
              </div>
              <div class="d-flex justify-end align-center mt-2" style="font-size:0.8rem;">
                <span>最后上传时间：</span>
                <span>{{ item.lastDateTime }}</span>
              </div>

              <z-echarts :timeList="item.timeList"
                         :dataList="item.valueList"
                         :index="index"
                         :unit="item.unit"
                         :warnRule="item.warnRule"
                         :type="item.chartType">
              </z-echarts>

            </v-card>
          </v-hover>
        </v-col>
      </v-row>

      <v-row v-if="activeParamInfo==1" style="background-color:#fff;">
        <v-col cols="4"
               v-for="(item,index) in nodeList"
               :key="index">
          <v-hover
              v-slot:default="{ hover }"
              open-delay="200"
          >
            <v-card
                @click="showHistoryData(item)"
                :elevation="hover ? 6 : 0"
                class="pa-2 fill-height"
                color
                light
            >
              <div class="d-flex justify-space-between align-center">
                <div class="d-flex align-center">
                  <!--01温度 02湿度 03压强 04电流 05开关量 06三相电流 07三相电压-->
                  <!--温度-->
                  <img src="@/assets/wd.png" v-if="item.collectDataType=='01'" class="iconStyle"
                       alt="">
                  <!--湿度-->
                  <img src="@/assets/sd.png" v-if="item.collectDataType=='02'" class="iconStyle"
                       alt="">
                  <!--开关-->
                  <img src="@/assets/yx.png" v-if="item.collectDataType=='05'" class="iconStyle"
                       alt="">
                  <!--压强-->
                  <img src="@/assets/yq.png" v-if="item.collectDataType=='03'" class="iconStyle"
                       alt="">
                  <!--电流-->
                  <img src="@/assets/zjdl.png"
                       v-if="item.collectDataType=='04'||item.collectDataType=='06'||item.collectDataType=='08'||item.collectDataType=='11'"
                       class="iconStyle" alt="">
                  <!--电压-->
                  <img src="@/assets/dy.png" v-if="item.collectDataType=='07'||item.collectDataType=='09'||item.collectDataType=='10'||item.collectDataType=='12'||item.collectDataType=='13'||item.collectDataType=='17' ||item.collectDataType=='21'" class="iconStyle"
                       alt="">
                  <span class="font-weight-black">{{ item.sensorSeq }}#</span>
                  <span class="font-weight-black">{{ item.collectPlace }}</span>
                  <span style="color:#666;font-size:0.875rem;">(
                    <!--预警规则 01大于 02小于 03等于 04不等于，展示取反-->
                                        <span v-if="item.warnRule=='01'"><=</span>
                                        <span v-if="item.warnRule=='02'">>=</span>
                                        <span v-if="item.warnRule=='03'">≠</span>
                                        <span v-if="item.warnRule=='04'">=</span>
                                        {{ item.collectDataType == '05' ? (item.warnValue == '1.0' ? '开' : '关') : (item.warnRule=='05' ? item.warnValue.replace(",", "~") : item.warnValue) }}
                                        <span v-if="item.collectDataType!='05'">{{ item.unit }}</span>)</span>
                </div>
                <div :class="item.isWarning?'currentNum warningCurrentNum':'currentNum'"
                     v-if="item.dataList.length>0">
                  {{ item.collectDataType == '05' ? (item.dataList.length > 0 ? (item.dataList[item.dataList.length - 1].value == 1 ? '开' : '关') : '') : (item.dataList.length > 0 ? item.dataList[item.dataList.length - 1].value : '') }}
                  <span v-if="item.collectDataType!='05'">{{ item.unit }}</span>
                </div>
              </div>
              <div class="d-flex justify-end align-center mt-2" style="font-size:0.8rem;">
                <span>最后上传时间：</span>
                <span>{{ item.lastDateTime }}</span>
              </div>

              <z-echarts :timeList="item.timeList"
                         :dataList="item.dataList"
                         :index="eqpLogList.length+index"
                         :unit="item.unit"
                         :warnRule="item.warnRule"
                         :warningValue='item.warnValue == null ? [99999] : (item.warnValue.indexOf(",") == -1 ? [item.warnValue * 1] : item.warnValue.split(",").map(Number)) '
                         :type="item.collectDataType">
              </z-echarts>

            </v-card>
          </v-hover>
        </v-col>
      </v-row>

      <v-row v-if="activeParamInfo==2">

        <!--    主机信息    -->
        <v-card
            width="100%"
            class="mx-auto"
        >

          <v-card-title class="headline">
            <img src="@/assets/wd.png" class="iconStyle" alt="">
            主机信息
            <span style="font-size: 15px;margin-left: 200px">最后更新时间: {{eqpInfo.eqpHostInfoVO.updateDateTime}}</span>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="editHostInfoDialogOpen">编辑</v-btn>
          </v-card-title>
          <v-simple-table>
            <template v-slot:default>
              <thead class="deep-purple lighten-5">
              <tr>
                <th class="text-left">主机型号</th>
                <th class="text-left">软件版本</th>
                <th class="text-left">CPU</th>
                <th class="text-left">内存</th>
                <th class="text-left">显卡</th>
                <th class="text-left">光驱</th>
                <th class="text-left">系统光盘</th>
                <th class="text-left">图像盘</th>
                <th class="text-left">阵列卡</th>
                <th class="text-left">其他板卡1</th>
                <th class="text-left">其他板卡2</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ eqpInfo.eqpHostInfoVO.hostModel }}</td>
                <td>{{ eqpInfo.eqpHostInfoVO.softwareVersion }}</td>
                <td>{{ eqpInfo.eqpHostInfoVO.cpu }}</td>
                <td>{{ eqpInfo.eqpHostInfoVO.memory }}</td>
                <td>{{ eqpInfo.eqpHostInfoVO.videoCard }}</td>
                <td>{{ eqpInfo.eqpHostInfoVO.cdDrive }}</td>
                <td>{{ eqpInfo.eqpHostInfoVO.systemHardDisk}}</td>
                <td>{{ eqpInfo.eqpHostInfoVO.imageDisk }}</td>
                <td>{{ eqpInfo.eqpHostInfoVO.arrayCard }}</td>
                <td>{{ eqpInfo.eqpHostInfoVO.otherBoards1 }}</td>
                <td>{{ eqpInfo.eqpHostInfoVO.otherBoards2 }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-simple-table>
            <template v-slot:default>
              <thead class="deep-purple lighten-5">
              <tr>
                <th class="text-left">探测器型号</th>
                <th class="text-left">安装光盘</th>
                <th class="text-left">备份参数</th>
                <th class="text-left">备注</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ eqpInfo.eqpHostInfoVO.detectorModel }}</td>
                <td>
                  {{ eqpInfo.eqpHostInfoVO.installationCdName }}
                  <v-btn x-small class="ma-2" @click="updateInstallationCdDialog = true">更新</v-btn>
                  <v-btn x-small color="primary" dark @click="downloadFile(eqpInfo.eqpHostInfoVO.installationCd)">下载</v-btn>
                </td>
                <td>
                  {{ eqpInfo.eqpHostInfoVO.backupParametersName }}
                  <v-btn x-small class="ma-2" @click="updateBackupParameterDialog = true">更新</v-btn>
                  <v-btn x-small color="primary" dark @click="downloadFile(eqpInfo.eqpHostInfoVO.backupParameters)">
                    下载</v-btn>
                </td>
                <td><span v-html="remarkUrlChange"></span>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>

        <!--    球管信息    -->
<!--        <v-card v-if=""-->
<!--                width="100%"-->
<!--                class="mx-auto mt-5"-->
<!--        >-->

<!--          <v-card-title class="headline">-->
<!--            <img src="@/assets/wd.png" class="iconStyle" alt="">球管信息                        <v-spacer></v-spacer>-->
<!--            <v-btn color="primary">编辑</v-btn>-->
<!--          </v-card-title>-->
<!--          <v-simple-table class="mb-10">-->
<!--            <template v-slot:default>-->
<!--              <thead class="deep-purple lighten-5">-->
<!--              <tr>-->
<!--                <th class="text-left">型号</th>-->
<!--                <th class="text-left">安装日期</th>-->
<!--                <th class="text-left">安装时曝光秒次</th>-->
<!--                <th class="text-left">额定曝光秒次</th>-->
<!--                <th class="text-left">当期曝光秒次</th>-->
<!--                <th class="text-left">可曝光秒次</th>-->
<!--                <th class="text-left">日均曝光秒次</th>-->
<!--                <th class="text-left">预警可用天数</th>-->
<!--                <th class="text-left">备注</th>-->
<!--              </tr>-->
<!--              </thead>-->
<!--              <tbody>-->
<!--              <tr>-->
<!--                <td>{{ eqpInfo.eqpRayTubeVO.rayTubeType }}</td>-->
<!--                <td>{{ eqpInfo.eqpRayTubeVO.createDateTime }}</td>-->
<!--                <td>{{ eqpInfo.eqpRayTubeVO.installExposureSecond }}</td>-->
<!--                <td>{{ eqpInfo.eqpRayTubeVO.ratedExposureSecond }}</td>-->
<!--                <td>{{ eqpInfo.eqpRayTubeVO.currentExposureSeconds }}</td>-->
<!--                <td>{{ eqpInfo.eqpRayTubeVO.canExposureSencond }}</td>-->
<!--                <td>{{ eqpInfo.eqpRayTubeVO.avgExposureSencondDay }}</td>-->
<!--                <td>{{ eqpInfo.eqpRayTubeVO.unableWarningDay }}</td>-->
<!--                <td>{{ eqpInfo.eqpRayTubeVO.remark }}</td>-->
<!--              </tr>-->
<!--              </tbody>-->
<!--            </template>-->
<!--          </v-simple-table>-->
<!--          &lt;!&ndash;todo:球管图表信息处理 &ndash;&gt;-->
<!--          <z-echarts :timeList="eqpInfo.timeList"-->
<!--                     :dataList="eqpInfo.dataList"-->
<!--                     :unit="'秒次'"-->
<!--                     :title="'球管每月曝光秒次'"-->
<!--                     ref="eqpRayTubeInfo"-->
<!--                     :index="0"-->
<!--                     :type="'01'">-->
<!--          </z-echarts>-->
<!--        </v-card>-->

        <!--    液氦信息(MRI)    -->
        <v-card v-if="this.eqpInfo.heLvlVO!=null && (this.cardList[activeEqpCard].daqType=='03' || this.cardList[activeEqpCard].daqType=='01')"
            width="100%"
            class="mx-auto mt-5"
        >
          <v-card-title class="headline">
            <img src="@/assets/wd.png" class="iconStyle" alt="">
            液氦水平
          </v-card-title>
          <z-echarts :timeList="heLvlValue.dateTime"
                     :dataList="heLvlValue.valueList"
                     :index=0
                     :unit="'%'"
                     :type="'01'">
          </z-echarts>
        </v-card>
      </v-row>

      <v-row v-if="activeParamInfo==3">
        <v-card width="100%">
          <v-card-title class="justify-center">
            <h2 >大设备运行日志</h2>
          </v-card-title>
          <v-row class="ml-2">
            <v-col cols="2">{{this.cardList[activeEqpCard].businessName}}</v-col>
            <v-col cols="2">{{this.cardList[activeEqpCard].eqpBrand}}</v-col>
            <v-col cols="2">{{this.cardList[activeEqpCard].eqpModel}}</v-col>
            <v-col cols="2">{{this.cardList[activeEqpCard].parentName}}</v-col>
            <v-col cols="2">{{this.cardList[activeEqpCard].hospName}}</v-col>
          </v-row>
          <!-- GE MR事件日志start-->
          <v-form  v-if="this.cardList[activeEqpCard].daqType=='01'" ref="eventLogQueryForm">
            <v-row class="ml-2">
              <v-col cols="5">
                <z-select-date v-model="geMrEventLogQueryRequest.dateTime"
                               :startDateRules="[]"
                               :endDateRules="[]"
                               ref="eventLogQuery"
                               :hide-details="true"/>
              </v-col>
              <v-col cols="2">
                <v-text-field label="Type" :hide-details="true" v-model="geMrEventLogQueryRequest.type"></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field label="Err Code" :hide-details="true" v-model="geMrEventLogQueryRequest.err"></v-text-field>
              </v-col>
              <v-col cols="3" class="mt-2">
                <v-btn class="ma-2" color="primary" @click="handleEventLogQuery">搜索</v-btn>
                <v-btn
                    fab
                    small
                    color="primary"
                    class="ma-2"
                    @click="resetQuery">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
                <!--<v-btn class="ma-2" color="primary">一键导出</v-btn>-->
              </v-col>
            </v-row>
          </v-form>
          <!-- GE MR事件日志end-->

          <!-- 飞利浦 CT事件日志start-->
          <v-form  v-if="this.cardList[activeEqpCard].daqType=='02'" ref="eventLogQueryForm">
            <v-row class="ml-2">
              <v-col cols="5">
                <z-select-date v-model="philipsCtEventLogQueryRequest.dateTime"
                               :startDateRules="[]"
                               :endDateRules="[]"
                               ref="eventLogQuery"
                               :hide-details="true"/>
              </v-col>
              <v-col cols="2">
                <v-text-field label="Type" :hide-details="true" v-model="philipsCtEventLogQueryRequest.type"></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field label="MSG" :hide-details="true" v-model="philipsCtEventLogQueryRequest.msg"></v-text-field>
              </v-col>
              <v-col cols="3" class="mt-2">
                <v-btn class="ma-2" color="primary" @click="handleEventLogQuery">搜索</v-btn>
                <v-btn
                        fab
                        small
                        color="primary"
                        class="ma-2"
                        @click="resetQuery">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
                <v-btn class="ma-2" color="primary">一键导出</v-btn>
              </v-col>
            </v-row>
          </v-form>
          <!-- 飞利浦 CT事件日志end-->
          <!--飞利浦 MR事件日志start-->
          <v-form  v-if="this.cardList[activeEqpCard].daqType=='03'" ref="eventLogQueryForm">
            <v-row class="ml-2">
              <v-col cols="5">
                <z-select-date v-model="philipsMrEventLogQueryRequest.dateTime"
                               :startDateRules="[]"
                               :endDateRules="[]"
                               ref="eventLogQuery"
                               :hide-details="true"/>
              </v-col>
              <v-col cols="2">
                <v-text-field label="MMU" :hide-details="true" v-model="philipsMrEventLogQueryRequest.mmuDetail"></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field label="DataValue" :hide-details="true" v-model="philipsMrEventLogQueryRequest.dataValue"></v-text-field>
              </v-col>
              <v-col cols="3" class="mt-2">
                <v-btn class="ma-2" color="primary" @click="handleEventLogQuery">搜索</v-btn>
                <v-btn
                        fab
                        small
                        color="primary"
                        class="ma-2"
                        @click="resetQuery">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
                <v-btn class="ma-2" color="primary">一键导出</v-btn>
              </v-col>
            </v-row>
          </v-form>
          <!--飞利浦 MR事件日志end-->
          <v-row class="justify-end">
            <v-col class="mr-3" cols="2">
              <v-text-field
                  v-model="logEventSearch"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-data-table
              v-if="this.cardList[activeEqpCard].daqType=='01'"
              :loading="loading.eventLogTableLoading"
              :headers="geMrEventLogQueryHeader"
              :items="geMrEventLogQueryInfo"
              :search="logEventSearch"
              :page.sync="geMrEventLogQueryRequest.pagedQueryInfo.index"
              :server-items-length="eventLogTotal"
              :options.sync="options"
          ></v-data-table>

          <v-data-table
                  v-if="this.cardList[activeEqpCard].daqType=='02'"
                  :loading="loading.eventLogTableLoading"
                  :headers="philipsCtEventLogQueryHeader"
                  :items="philipsCtEventLogQueryInfo"
                  :search="logEventSearch"
                  :page.sync="philipsCtEventLogQueryRequest.pagedQueryInfo.index"
                  :server-items-length="eventLogTotal"
                  :options.sync="options"
          ></v-data-table>
          <v-data-table
                  v-if="this.cardList[activeEqpCard].daqType=='03'"
                  :loading="loading.eventLogTableLoading"
                  :headers="philipsMrEventLogQueryHeader"
                  :items="philipsMrEventLogQueryInfo"
                  :search="logEventSearch"
                  :page.sync="philipsMrEventLogQueryRequest.pagedQueryInfo.index"
                  :server-items-length="eventLogTotal"
                  :options.sync="options"
          ></v-data-table>
        </v-card>
      </v-row>

    </v-container>

    <div
        v-else>
      <v-img
          class="mb-4 mt-12"
          height="15rem"
          contain
          src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/kong%402x.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753406039&Signature=zkn31yjSUaL9OqvbbvJZ%2F0K%2F8zM%3D"></v-img>
    </div>

    <!--历史数据dialog start-->
    <v-dialog v-model="historyDialog"
              max-width="60%">
      <v-card>
        <div class="text-center pt-4 font-weight-bold">{{historyObj.collectPlace}}</div>
        <div class="d-flex align-center justify-center pt-2"
             style="font-size:0.875rem;color:#666;">
          <div class="ml-4 mr-4">
            <span>绑定对象：</span>
            <span>{{historyObj.collectorVO?historyObj.collectorVO.businessName:''}}</span>
          </div>
          <!--<div class="ml-4 mr-4">-->
          <!--<span>设备品牌：</span>-->
          <!--<span>{{'设备品牌'}}</span>-->
          <!--</div>-->
          <div class="ml-4 mr-4">
            <span>设备型号：</span>
            <span>{{historyObj.collectorVO?historyObj.collectorVO.collectorModel:''}}</span>
          </div>
          <div class="ml-4 mr-4">
            <span>出厂序列号：</span>
            <span>{{historyObj.collectorVO?(!historyObj.collectorVO.eqpFactSerialNo?'无':historyObj.collectorVO.eqpFactSerialNo):''}}</span>
          </div>
        </div>
        <v-divider class="mt-4 mb-4"></v-divider>

        <div>
          <v-btn class="ma-2"
                 v-for="(item,index) in timeBtnList"
                 :key="index"
                 :outlined="activeTime==item.value?false:true"
                 color="primary"
                 @click="getHistoryData(item)">{{item.item}}
          </v-btn>
        </div>

        <z-echarts ref="historyEchartsView"
                   v-if="historyEcharts"
                   :timeList="historyObj.timeList"
                   :dataList="historyObj.dataList"
                   :type="historyType"
                   :index="nodeList.length+eqpLogList.length"
                   :unit="historyObj.unit"
                   :warnRule="historyObj.warnRule"
                   :warningValue='historyObj.warnValue == null ? [99999] : (historyObj.warnValue.indexOf(",") == -1 ? [historyObj.warnValue * 1] : historyObj.warnValue.split(",").map(Number)) '
        ></z-echarts>

      </v-card>
    </v-dialog>
    <!--历史数据dialog end-->

    <v-dialog v-model="editHostInfoDialog" width="800px">
      <v-card width="801px">
        <v-card-title class="headline">主机信息编辑</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-text-field v-model="editEqpHostInfoRequest.hostModel" label="主机型号"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="editEqpHostInfoRequest.softwareVersion" label="软件版本"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="editEqpHostInfoRequest.cpu" label="CPU"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="editEqpHostInfoRequest.memory" label="内存"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="editEqpHostInfoRequest.videoCard" label="显卡"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="editEqpHostInfoRequest.cdDrive" label="光驱"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="editEqpHostInfoRequest.systemHardDisk" label="系统光盘"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="editEqpHostInfoRequest.imageDisk" label="图像盘"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="editEqpHostInfoRequest.arrayCard" label="阵列卡"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="editEqpHostInfoRequest.otherBoards1" label="其他板卡1"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="editEqpHostInfoRequest.otherBoards2" label="其他板卡2"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="editEqpHostInfoRequest.detectorModel" label="探测器型号"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="editEqpHostInfoRequest.remark" label="备注"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="editHostInfoDialog=false">取消</v-btn>
          <v-btn color="primary" text @click="editHostInfoCommit">提交</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <z-loading v-model="loading.isLoading"></z-loading>

    <v-dialog
        v-model="updateInstallationCdDialog"
        max-width="60%">
      <div style="background-color:#fff;" class="pb-12">
        <v-card-title class="font-weight-bold">
          上传安装光盘文件
        </v-card-title>
        <v-row no-gutters justify="center">
          <v-col
              cols="6">
            <v-form
                ref="uploadFileForm"
                v-model="uploadFormValid"
            >
              <v-file-input
                  v-model="fileInfo"
                  required
                  :rules="[v => !!v || '文件必选']"
                  show-size
                  @change="uploadFile"
                  :disabled="loading.uploadIsLoading"
                  :loading="loading.uploadIsLoading"
                  label="单个文件最大支持上传1GB"></v-file-input>
            </v-form>

          </v-col>
        </v-row>
      </div>
    </v-dialog>

    <v-dialog
        v-model="updateBackupParameterDialog"
        max-width="60%">
      <div style="background-color:#fff;" class="pb-12">
        <v-card-title class="font-weight-bold">
          备份参数文件上传
        </v-card-title>
        <v-row no-gutters justify="center">
          <v-col
              cols="6">
            <v-form
                ref="uploadBackupParameterForm"
                v-model="uploadFormValid"
            >
              <v-file-input
                  v-model="uploadBackupParameterFile"
                  required
                  :rules="[v => !!v || '文件必选']"
                  show-size
                  @change="uploadBackUpFile"
                  :disabled="loading.uploadIsLoading"
                  :loading="loading.uploadIsLoading"
                  label="单个文件最大支持上传1GB"></v-file-input>
            </v-form>

          </v-col>
        </v-row>
      </div>
    </v-dialog>

    <z-notify ref="notify"></z-notify>
  </v-container>
</template>

<script>
import ZSourceSelector from "@/components/ZSourceSelector"
import ZEcharts from "@/components/ZEcharts"
import ZLoading from "@/components/ZLoading"
import ZSelectDate from "@/components/ZSelectDate"
import {
  queryHospCollectCount,
  queryEqpList,
  queryChartQuery,
  historyChartQuery,
  eqpLogChartQuery,
  daqTypeEqpInfoQuery,
  geMrEventLogQuery,
  philipsCtEventLogQuery,
  philipsMrEventLogQuery,
  eqpHostInfoUpdate,
  eqpLogReport,
  updateInstallationCd,
  updateBackupParameter
} from '@/api/realTimeDataMonitor'
import {collectorImport} from "@/api/collectorManagement";

export default {
  name: "RealTimeDataMonitor",
  data: () => ({
    options: {},
    logEventSearch :'',
    loading:{
      isLoading:false,
      nodeListLoading:false,
      daqTypeEqpInfoLoading:false,
      queryEqpLogChartLoading:false,
      eventLogTableLoading:false,
      uploadIsLoading:false,
    },
    fileInfo:null,
    uploadBackupParameterFile:null,
    cardList: [],
    activeEqpCard: 0,
    activeParamInfo: 0,
    activeParamButton :true,
    historyDialog: false,
    editHostInfoDialog: false,
    historyEcharts: false,
    updateInstallationCdDialog:false,
    updateBackupParameterDialog:false,
    uploadFormValid:false,
    activeTime: '01',
    timeBtnList: [
      {
        item: '近一周',
        value: '01'
      },
      // {
      //   item: '近十月',
      //   value: 1
      // },
      {
        item: '近一月',
        value: '02'
      },
      {
        item: '近二月',
        value: '03'
      },
      {
        item: '近三月',
        value: '04'
      }
    ],
    nodeList: [],
    eqpLogList:[],
    heLvlValue:{
      dateTime:[],
      valueList:[]
    },
    historyXData: [],
    historyDataList: [],
    historyType: '',

    historyObj: {},

    currentHospId: '',
    hospList: [],
    currentHospEqpNum: 0,
    currentNodeId:"",
    businessId:'',
    //eqpInfoQuery
    eqpInfo:{
      //主机信息
      eqpHostInfoVO:{},
      // //球管信息
      // eqpRayTubeVO:{},
      // //球管图表
      // chartDataList: [
      // ],
      heLvlVO:{},
    },
    editEqpHostInfoRequest:{},
    //运行日志查询
    geMrEventLogQueryRequest:{
      "id": "",
      "eqpId": "",
      "date": "",
      "time": "",
      "dateTime":[],
      "type": "",
      "err": "",
      "message": "",
      "createDateTime": "",
      "updateDateTime": "",
      "companyId": "",
      "sortBy": "time",
      "sortAsc": false,
      "pagedQueryInfo": {
        "index": 1,
        "pageSize": 10
      }
    },
    philipsCtEventLogQueryRequest: {
      "id": "",
      "tstampNum": "",
      "blob": "",
      "dataTime": "",
      "dateTime": [],
      "eal": "",
      "level": null,
      "logDataTime": "",
      "module": "",
      "msg": "",
      "shortDateTime": "",
      "type": "",
      "companyId": "",
      "eqpId": "",
      "createDateTime": "",
      "sortBy": "dataTime",
      "sortAsc": false,
      "pagedQueryInfo": {
          "index": 1,
          "pageSize": 10
      }
    },
    philipsMrEventLogQueryRequest: {
        "id": "",
        "logDateTime": "",
        "mmuDetail": "",
        "mmuDetailDesc": "",
        "column1": "",
        "dataValue": "",
        "column2": "",
        "column3": "",
        "column4": "",
        "dateTime":[],
        "longDateTime": "",
        "createDateTime": "",
        "updateDateTime": "",
        "eqpId": "",
        "sortBy": "longDateTime",
        "sortAsc": false,
        "pagedQueryInfo": {
            "index": 1,
            "pageSize": 10
        }
    },
    //设备导出
    eqpExport:{
      "eqpId": "",
      "daqType": ""
    },
    //运行日志头
    geMrEventLogQueryHeader:[
      {text: 'Date', value: 'date', sortable: false},
      {text: 'Time', value: 'time', sortable: false},
      {text: 'Type', value: 'type', sortable: false},
      {text: 'Err', value: 'err',sortable: false},
      {text: 'Message', value: 'message', sortable: false},
    ],
    philipsCtEventLogQueryHeader:[
      {text: 'Type', value: 'type', sortable: false},
      {text: 'Level', value: 'level', sortable: false},
      {text: 'Module', value: 'module', sortable: false},
      {text: 'TStampNum', value: 'tStampNum',sortable: false},
      {text: 'DataTime', value: 'dataTime', sortable: false},
      {text: 'Msg', value: 'msg', sortable: false},
      {text: 'Eal', value: 'eal', sortable: false},
      {text: 'Blob', value: 'blob', sortable: false},
      // {text: 'DateTime', value: 'dateTime', sortable: false},
    ],
    philipsMrEventLogQueryHeader:[
        {text: 'LogDateTime', value: 'logDateTime', sortable: false},
        {text: 'MMU', value: 'mmuDetail', sortable: false},
        {text: 'DESC', value: 'mmuDetailDesc', sortable: false},
        {text: 'Column1', value: 'column1',sortable: false},
        {text: 'Column2', value: 'column2', sortable: false},
        {text: 'DataValue', value: 'dataValue', sortable: false},
        {text: 'Column3', value: 'column3', sortable: false},
        {text: 'Column4', value: 'column4', sortable: false},
        {text: 'DateTime', value: 'dateTime', sortable: false},
    ],
    //运行日志列表信息
    geMrEventLogQueryInfo:[],
    philipsCtEventLogQueryInfo:[],
    philipsMrEventLogQueryInfo:[],
    eventLogTotal:0,
    //备注转换链接
    remarkUrlChange:"",
    eqpId:''
  }),
  components: {
    ZSourceSelector,
    ZEcharts,
    ZLoading,
    ZSelectDate,
  },
  watch: {
    historyDialog(newValue, oldValue) {
      if (!newValue) {
        this.historyEcharts = newValue;
      }
    },
    options: {
      handler(val) {
        if (val.itemsPerPage == -1) {
          if (this.cardList[this.activeEqpCard].daqType=='01') {
            this.geMrEventLogQueryRequest.pagedQueryInfo.index = 1
            this.geMrEventLogQueryRequest.pagedQueryInfo.pageSize = 999999
          }
          if (this.cardList[this.activeEqpCard].daqType=='02') {
            this.philipsCtEventLogQueryRequest.pagedQueryInfo.index = 1
            this.philipsCtEventLogQueryRequest.pagedQueryInfo.pageSize = 999999
          }
          if (this.cardList[this.activeEqpCard].daqType=='03') {
            this.philipsMrEventLogQueryRequest.pagedQueryInfo.index = 1
            this.philipsMrEventLogQueryRequest.pagedQueryInfo.pageSize = 999999
          }
        } else if (!!val.page && !!val.itemsPerPage) {
          if (this.cardList[this.activeEqpCard].daqType=='01') {
            this.geMrEventLogQueryRequest.pagedQueryInfo.index = val.page
            this.geMrEventLogQueryRequest.pagedQueryInfo.pageSize = val.itemsPerPage
            this.eventLogQuery('01')
          }
          if (this.cardList[this.activeEqpCard].daqType=='02') {
            this.philipsCtEventLogQueryRequest.pagedQueryInfo.index = val.page
            this.philipsCtEventLogQueryRequest.pagedQueryInfo.pageSize = val.itemsPerPage
            this.eventLogQuery('02')
          }
          if (this.cardList[this.activeEqpCard].daqType=='03') {
            this.philipsMrEventLogQueryRequest.pagedQueryInfo.index = val.page
            this.philipsMrEventLogQueryRequest.pagedQueryInfo.pageSize = val.itemsPerPage
            this.eventLogQuery('03')
          }
        }
      }
    },
  },
  methods: {
    //
    resetQuery() {
      this.geMrEventLogQueryRequest.type = "";
      this.geMrEventLogQueryRequest.err = "";
      this.geMrEventLogQueryRequest.dateTime = [];

      this.philipsCtEventLogQueryRequest.mmuDetail = "";
      this.philipsCtEventLogQueryRequest.dataValue = "";
      this.philipsCtEventLogQueryRequest.dateTime = [];

      this.philipsMrEventLogQueryRequest.mmuDetail = "";
      this.philipsMrEventLogQueryRequest.dataValue = "";
      this.philipsMrEventLogQueryRequest.dateTime = [];
      console.log(this.$refs.eventLogQuery,'---------this.$refs.eventLogQuery.----------');
      this.$refs.eventLogQuery.queryData =  {
        startDateTime: '',
        endDateTime: '',
        startDate: '',
        endDate: '',
        startTime: '00:00:00',
        endTime: '00:00:00'
      }
    },
    // 切换医院
    changeHosp(val) {
      console.log(val, '切换医院');
      // this.hospList.forEach(option => {
      //   if (option.id == val) {
      //     this.currentHospEqpNum = option.collectorCount
      //   }
      // });
      this.activeEqpCard = 0;
      // 更新医院下设备
      this.queryEqpListAjax();
    },
    // 获取用户下所有医院以及医院下设备的数量
    queryHospCollectCount(id) {
      var req = {
        pagedQueryInfo: {
          index: 1,
          pageSize: 9999
        }
      };
      this.loading.isLoading=true;
      queryHospCollectCount(req).then(res => {
        // res.list.forEach(option => {
        //   option.hospName=option.hospName+'('+option.collectorCount+')';
        // });
        this.hospList = res.list;

        if (id) {
          this.currentHospId = id;
          this.changeHosp(id);
        } else if (this.hospList.length > 0) {
          // 如果从菜单栏进入，默认取第一个医院展示
        }
        if(this.loading.daqTypeEqpInfoLoading == false && this.loading.queryEqpLogChartLoading ==false && this.loading.nodeListLoading ==false){
          this.loading.eventLogTableLoading = false;
          this.loading.uploadIsLoading = false;
          this.loading.daqTypeEqpInfoLoading = false;
          this.loading.queryEqpLogChartLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.isLoading = false;
        }
      }).catch(err => {
          this.loading.eventLogTableLoading = false;
          this.loading.uploadIsLoading = false;
          this.loading.daqTypeEqpInfoLoading = false;
          this.loading.queryEqpLogChartLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.isLoading = false;
      });
    },
    // 查找医院下设备
    queryEqpListAjax() {
      var req = {};
      req.hospId = this.currentHospId;
      req.pagedQueryInfo = {
        index: 1,
        pageSize: 9999
      };
      this.loading.isLoading=true;

      queryEqpList(req).then(res => {
        this.cardList = res.list;
        // 假如医院下无设备就不必再去调用某个设备下查找节点配置的接口的了
        if(this.cardList.length<1){
          this.nodeList=[];
          return;
        }
        this.currentHospEqpNum = this.cardList.length;
        this.eqpLogList = [];
        this.heLvlValue = {
          dateTime: [],
          valueList: []
        }
        this.nodeList=[];
        if(this.businessId){
          // 当从大屏的预警弹框点击进入实时监控页面时（带了医院id和设备id）
          for(var i=0;i<this.cardList.length;i++){
            if(this.cardList[i].id==this.businessId){
              this.activeEqpCard=i;
            }
          }
          if(this.cardList[this.activeEqpCard].monitorType == "01"){
            //监控对象为采集器
            this.queryChartQuery(this.cardList[this.activeEqpCard].id);
            this.activeParamButton = true;
          }else if(this.cardList[this.activeEqpCard].monitorType == "02"){
            //监控对象为日志
            this.activeParamButton = false;
            this.queryEqpLogChart(this.cardList[this.activeEqpCard].businessId, this.cardList[this.activeEqpCard].daqType);
            this.daqTypeEqpInfoQuery(this.cardList[this.activeEqpCard].businessId);
            this.eventLogQuery(this.cardList[this.activeEqpCard].daqType);
          }else{
            this.activeParamButton = false;
            this.queryChartQuery(this.cardList[this.activeEqpCard].id);
            this.queryEqpLogChart(this.cardList[this.activeEqpCard].businessId, this.cardList[this.activeEqpCard].daqType);
            this.daqTypeEqpInfoQuery(this.cardList[this.activeEqpCard].businessId)
            this.eventLogQuery(this.cardList[this.activeEqpCard].daqType);
          }
        }else if(this.eqpId){
          for(var i=0;i<this.cardList.length;i++){
            if(this.cardList[i].businessId==this.eqpId){
              this.activeEqpCard=i;
              this.businessId=this.cardList[i].id;
            }
          }
          if(this.cardList[this.activeEqpCard].monitorType == "01"){
            //监控对象为采集器
            this.queryChartQuery(this.cardList[this.activeEqpCard].id);
            this.activeParamButton = true;
          }else if(this.cardList[this.activeEqpCard].monitorType == "02"){
            //监控对象为日志
            this.activeParamButton = false;
            this.queryEqpLogChart(this.cardList[this.activeEqpCard].businessId, this.cardList[this.activeEqpCard].daqType);
            this.daqTypeEqpInfoQuery(this.cardList[this.activeEqpCard].businessId)
            this.eventLogQuery(this.cardList[this.activeEqpCard].daqType);
          }else{
            this.activeParamButton = false;
            this.queryChartQuery(this.cardList[this.activeEqpCard].id);
            this.queryEqpLogChart(this.cardList[this.activeEqpCard].businessId, this.cardList[this.activeEqpCard].daqType);
            this.daqTypeEqpInfoQuery(this.cardList[this.activeEqpCard].businessId)
            this.eventLogQuery(this.cardList[this.activeEqpCard].daqType);
          }
          this.businessId='';
        }else{
          if(this.cardList[0].monitorType == "01"){
            //监控对象为采集器
            this.activeParamButton = true;
            this.queryChartQuery(this.cardList[0].id);
          }else if(this.cardList[0].monitorType == "02"){
            //监控对象为日志
            this.activeParamButton = false;
            this.queryEqpLogChart(this.cardList[0].businessId, this.cardList[0].daqType);
            this.daqTypeEqpInfoQuery(this.cardList[0].businessId);
            this.eventLogQuery(this.cardList[0].daqType);
          }else{
            this.activeParamButton = false;
            this.queryChartQuery(this.cardList[0].id);
            this.queryEqpLogChart(this.cardList[0].businessId, this.cardList[0].daqType);
            this.daqTypeEqpInfoQuery(this.cardList[0].businessId);
            this.eventLogQuery(this.cardList[0].daqType);
          }
        }
        if(this.loading.daqTypeEqpInfoLoading == false && this.loading.queryEqpLogChartLoading ==false && this.loading.nodeListLoading ==false){
            this.loading.eventLogTableLoading = false;
            this.loading.uploadIsLoading = false;
            this.loading.daqTypeEqpInfoLoading = false;
            this.loading.queryEqpLogChartLoading = false;
            this.loading.nodeListLoading = false;
            this.loading.isLoading = false;
        }
      }).catch(err => {
          this.loading.eventLogTableLoading = false;
          this.loading.uploadIsLoading = false;
          this.loading.daqTypeEqpInfoLoading = false;
          this.loading.queryEqpLogChartLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.isLoading = false;
      })
    },
    clickCard(num, index, key) {
      this.activeParamInfo = 1
      this.activeEqpCard = num * index + key;
      this.loading.isLoading = true;
      this.eqpLogList = [];
      this.heLvlValue = {
        dateTime: [],
        valueList: []
      }
      this.nodeList=[];
      if(this.cardList[this.activeEqpCard].monitorType == "01"){
        //监控对象为采集器
        this.queryChartQuery(this.cardList[this.activeEqpCard].id);
        this.activeParamButton = true;
      }else if(this.cardList[this.activeEqpCard].monitorType == "02"){
        //监控对象为日志
        this.activeParamButton = false;
        this.queryEqpLogChart(this.cardList[this.activeEqpCard].businessId, this.cardList[this.activeEqpCard].daqType);
        this.daqTypeEqpInfoQuery(this.cardList[this.activeEqpCard].businessId);
        this.eventLogQuery(this.cardList[this.activeEqpCard].daqType);
      }else{
        this.activeParamButton = false;
        this.queryChartQuery(this.cardList[this.activeEqpCard].id);
        this.queryEqpLogChart(this.cardList[this.activeEqpCard].businessId, this.cardList[this.activeEqpCard].daqType);
        this.daqTypeEqpInfoQuery(this.cardList[this.activeEqpCard].businessId);
        this.eventLogQuery(this.cardList[this.activeEqpCard].daqType);
      }
    },
    showHistoryData(item) {
      // echarts一定要先赋值再渲染，第一次打开默认展示近一周的
      // WEEK1("01", "近一周"),
      //   MONTH1("02", "近一月"),
      //   MONTH2("03", "近二月"),
      //   MONTH3("04", "近三月"),
      this.currentNodeId=item.id;
      var req = {
        dateType: "01",
        id: this.currentNodeId
      };
      this.loading.isLoading=true;
      historyChartQuery(req).then(res => {
        res.timeList = [];
        res.dataList = [];
        for (var i = 0; i < res.chartDataList.length; i++) {
          res.timeList.push(res.chartDataList[i].chartDate);
          if (res.chartDataList[i].isWarning) {
            res.dataList.push({
              value: res.chartDataList[i].chartValue,
              chartDate: res.chartDataList[i].chartDate,
              isWarning: res.chartDataList[i].isWarning,
              beforeWarningValue: res.chartDataList[i].beforeWarningValue,
              startWarningValue: res.chartDataList[i].startWarningValue,
              endWarningValue: res.chartDataList[i].endWarningValue,
              afterWarningValue: res.chartDataList[i].afterWarningValue
            });
          } else {
            res.dataList.push({value: res.chartDataList[i].chartValue, isWarning: res.chartDataList[i].isWarning});
          }
        }
        this.historyObj = res;
        this.historyType = item.collectDataType;
        this.activeTime = '01';
        this.loading.isLoading=false;
        this.loading.eventLogTableLoading = false;
        this.loading.uploadIsLoading = false;
        this.loading.daqTypeEqpInfoLoading = false;
        this.loading.queryEqpLogChartLoading = false;
        this.loading.nodeListLoading = false;
        this.loading.isLoading = false;
        this.historyDialog = true;
        this.$nextTick(() => {
          this.historyEcharts = true;
        })
      }).catch(err => {
          this.loading.eventLogTableLoading = false;
          this.loading.uploadIsLoading = false;
          this.loading.daqTypeEqpInfoLoading = false;
          this.loading.queryEqpLogChartLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.isLoading = false;

      });
    },
    // 点击按月获取按钮
    getHistoryData(item) {
      this.activeTime = item.value;
      // WEEK1("01", "近一周"),
      //   MONTH1("02", "近一月"),
      //   MONTH2("03", "近二月"),
      //   MONTH3("04", "近三月"),
      var req = {
        dateType: item.value,
        id: this.currentNodeId
      };
      this.loading.isLoading=true;
      historyChartQuery(req).then(res => {
        res.timeList = [];
        res.dataList = [];
        for (var i = 0; i < res.chartDataList.length; i++) {
          res.timeList.push(res.chartDataList[i].chartDate);
          if (res.chartDataList[i].isWarning) {
            res.dataList.push({
              value: res.chartDataList[i].chartValue,
              chartDate: res.chartDataList[i].chartDate,
              isWarning: res.chartDataList[i].isWarning,
              beforeWarningValue: res.chartDataList[i].beforeWarningValue,
              startWarningValue: res.chartDataList[i].startWarningValue,
              endWarningValue: res.chartDataList[i].endWarningValue,
              afterWarningValue: res.chartDataList[i].afterWarningValue
            });
          } else {
            res.dataList.push({value: res.chartDataList[i].chartValue, isWarning: res.chartDataList[i].isWarning});
          }
        }
        this.historyObj = res;
          this.loading.eventLogTableLoading = false;
          this.loading.uploadIsLoading = false;
          this.loading.daqTypeEqpInfoLoading = false;
          this.loading.queryEqpLogChartLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.isLoading = false;
        // 赋值之后重新画echarts
        this.$refs.historyEchartsView.setInitEcharts();
      }).catch(err => {
          this.loading.eventLogTableLoading = false;
          this.loading.uploadIsLoading = false;
          this.loading.daqTypeEqpInfoLoading = false;
          this.loading.queryEqpLogChartLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.isLoading = false;
      });

    },
    // 主机编辑窗口打开
    editHostInfoDialogOpen(){
      this.editHostInfoDialog = true
      Object.assign(this.editEqpHostInfoRequest ,this.eqpInfo.eqpHostInfoVO)
      this.editEqpHostInfoRequest.installationCd =null
      this.editEqpHostInfoRequest.installationCdName =null
      this.editEqpHostInfoRequest.backupParametersName =null
      this.editEqpHostInfoRequest.backupParameters =null
    },
    // 主机编辑提交
    editHostInfoCommit(){
      eqpHostInfoUpdate(this.editEqpHostInfoRequest).then(res=>{
        this.$refs.notify.show("提交成功", {
          timeout: 1000,
          color: 'success'
        });
        this.editHostInfoDialog = false
        this.daqTypeEqpInfoQuery(this.editEqpHostInfoRequest.eqpId);
      }).catch(()=>{
        this.editHostInfoDialog = false
      })
    },
    queryChartQuery(id) {
      var req = {
        id: id
      };
      this.loading.nodeListLoading=true;
      this.loading.isLoading=true;
      queryChartQuery(req).then(res => {
        this.loading.nodeListLoading=false;
        res.forEach(option => {
          option.timeList = [];
          option.dataList = [];
          for (var i = 0; i < option.chartDataList.length; i++) {
            option.timeList.push(option.chartDataList[i].chartDate);
            if (option.chartDataList[i].isWarning) {
              option.dataList.push({
                value: option.chartDataList[i].chartValue,
                chartDate: option.chartDataList[i].chartDate,
                isWarning: option.chartDataList[i].isWarning,
                beforeWarningValue: option.chartDataList[i].beforeWarningValue,
                startWarningValue: option.chartDataList[i].startWarningValue,
                endWarningValue: option.chartDataList[i].endWarningValue,
                afterWarningValue: option.chartDataList[i].afterWarningValue
              });
            } else {
              option.dataList.push({
                value: option.chartDataList[i].chartValue,
                isWarning: option.chartDataList[i].isWarning
              });
            }
          }
        });
        this.nodeList = res;
        if(this.loading.daqTypeEqpInfoLoading == false && this.loading.queryEqpLogChartLoading ==false && this.loading.nodeListLoading ==false){
          this.loading.eventLogTableLoading = false;
          this.loading.uploadIsLoading = false;
          this.loading.daqTypeEqpInfoLoading = false;
          this.loading.queryEqpLogChartLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.isLoading = false;
        }
      }).catch(err => {
          this.loading.eventLogTableLoading = false;
          this.loading.uploadIsLoading = false;
          this.loading.daqTypeEqpInfoLoading = false;
          this.loading.queryEqpLogChartLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.isLoading = false;
      });
    },
    //获取设备日志图表
    queryEqpLogChart(id, daqType) {
      var req = {
        eqpId: id,
        daqType: daqType,
      };
      this.loading.queryEqpLogChartLoading = true;
      this.loading.isLoading=true;
      eqpLogChartQuery(req).then(res => {
        res.forEach(option => {
          option.timeList = [];
          option.valueList = [];
          for (let i = 0; i < option.dataList.length; i++) {
            option.timeList.push(option.dataList[i].dateTime);
            option.valueList.push({
              value: option.dataList[i].value,
              isWarning: false
            });
          }
        });
        this.eqpLogList = res;
        this.loading.queryEqpLogChartLoading = false
        if(this.loading.daqTypeEqpInfoLoading == false && this.loading.queryEqpLogChartLoading ==false && this.loading.nodeListLoading ==false){
            this.loading.eventLogTableLoading = false;
            this.loading.uploadIsLoading = false;
            this.loading.daqTypeEqpInfoLoading = false;
            this.loading.queryEqpLogChartLoading = false;
            this.loading.nodeListLoading = false;
            this.loading.isLoading = false;
        }
      }).catch(err => {
          this.loading.eventLogTableLoading = false;
          this.loading.uploadIsLoading = false;
          this.loading.daqTypeEqpInfoLoading = false;
          this.loading.queryEqpLogChartLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.isLoading = false;
      });
    },
    //采集型设备基本信息查询
    daqTypeEqpInfoQuery(data) {
      var req = {
        eqpId: data,
      };
      this.loading.daqTypeEqpInfoLoading = true;
      this.loading.isLoading = true;
      daqTypeEqpInfoQuery(req).then(res => {
        this.eqpInfo = res;
        this.remarkUrlChange = "",
        this.urlCheck();
        this.heLvlValue = {
          dateTime: [],
          valueList: []
        }
        if(this.eqpInfo.heLvlVO !=null){
          for (let i = 0; i < this.eqpInfo.heLvlVO.heLvlChartList.length; i++) {
            this.heLvlValue.dateTime.push(this.eqpInfo.heLvlVO.heLvlChartList[i].dateTime);
            this.heLvlValue.valueList.push({
              value: this.eqpInfo.heLvlVO.heLvlChartList[i].heLvlValue,
              isWarning: false
            });
          }
        }
        this.loading.daqTypeEqpInfoLoading = false;
        if(this.loading.daqTypeEqpInfoLoading == false && this.loading.queryEqpLogChartLoading ==false && this.loading.nodeListLoading ==false){
            this.loading.eventLogTableLoading = false;
            this.loading.uploadIsLoading = false;
            this.loading.daqTypeEqpInfoLoading = false;
            this.loading.queryEqpLogChartLoading = false;
            this.loading.nodeListLoading = false;
            this.loading.isLoading = false;
        }
      }).catch(err => {
          this.loading.eventLogTableLoading = false;
          this.loading.uploadIsLoading = false;
          this.loading.daqTypeEqpInfoLoading = false;
          this.loading.queryEqpLogChartLoading = false;
          this.loading.nodeListLoading = false;
          this.loading.isLoading = false;
      });
    },
    handleEventLogQuery(){
      this.geMrEventLogQueryRequest.pagedQueryInfo.index=1;
      this.philipsCtEventLogQueryRequest.pagedQueryInfo.index=1;
      this.philipsMrEventLogQueryRequest.pagedQueryInfo.index=1;
      this.eventLogQuery(this.cardList[this.activeEqpCard].daqType);
    },
    //大设备运行日志查询
    eventLogQuery(type){
      if(type=='01'){
        // this.geMrEventLogQueryRequest.sortBy = "dateTime"
        // this.geMrEventLogQueryRequest.sortAsc = false
        this.geMrEventLogQueryRequest.eqpId = this.cardList[this.activeEqpCard].businessId
        this.loading.eventLogTableLoading = true;
          geMrEventLogQuery(this.geMrEventLogQueryRequest).then(res=>{
          this.geMrEventLogQueryInfo = res.list;
          this.eventLogTotal = res.total
          this.loading.eventLogTableLoading = false;
        }).catch(err=>{
          this.loading.eventLogTableLoading = false;
        });
      }
      if(type=='02'){
        // this.philipsCtEventLogQueryRequest.sortBy = "dateTime"
        // this.philipsCtEventLogQueryRequest.sortAsc = false
        this.philipsCtEventLogQueryRequest.eqpId = this.cardList[this.activeEqpCard].businessId
        this.loading.eventLogTableLoading = true;
        philipsCtEventLogQuery(this.philipsCtEventLogQueryRequest).then(res=>{
          this.philipsCtEventLogQueryInfo = res.list;
          this.eventLogTotal = res.total
          this.loading.eventLogTableLoading = false;
        }).catch(err=>{
          this.loading.eventLogTableLoading = false;
        });
      }
      if(type=='03'){
        // this.philipsCtEventLogQueryRequest.sortBy = "dateTime"
        // this.philipsCtEventLogQueryRequest.sortAsc = false
        this.philipsCtEventLogQueryRequest.eqpId = this.cardList[this.activeEqpCard].businessId
        this.loading.eventLogTableLoading = true;
        console.log(this.philipsMrEventLogQueryRequest);
        philipsMrEventLogQuery(this.philipsMrEventLogQueryRequest).then(res=>{
            this.philipsMrEventLogQueryInfo = res.list;
            this.eventLogTotal = res.total
            this.loading.eventLogTableLoading = false;
        }).catch(err=>{
            this.loading.eventLogTableLoading = false;
        });
      }
    },
    //光盘文件上传
    uploadFile() {
      // console.log(this.fileInfo, '文件信息');
      this.uploadFileCheck(this.fileInfo)
      if (this.$refs.uploadFileForm.validate()) {
        this.loading.uploadIsLoading = true;
        var formData = new window.FormData()
        formData.append('file', this.fileInfo);
        formData.append('id', this.eqpInfo.eqpHostInfoVO.id);
        updateInstallationCd(formData).then(res => {
          this.loading.uploadIsLoading = false;
          this.$refs.notify.show("文件上传成功", {timeout: 1000, color: 'success'});
          this.updateInstallationCdDialog = false;
          this.daqTypeEqpInfoQuery(this.cardList[this.activeEqpCard].businessId);
        }).catch(err => {
          this.loading.uploadIsLoading = false;
        });
      }
    },
    uploadBackUpFile() {
      this.uploadFileCheck(this.uploadBackupParameterFile)
      if (this.$refs.uploadBackupParameterForm.validate()) {
        this.loading.uploadIsLoading = true;
        var formData = new window.FormData()
        formData.append('file', this.uploadBackupParameterFile);
        formData.append('id', this.eqpInfo.eqpHostInfoVO.id);
        updateBackupParameter(formData).then(res => {
          this.loading.uploadIsLoading = false;
          this.$refs.notify.show("文件上传成功", {timeout: 1000, color: 'success'});
          this.updateBackupParameterDialog = false;
          this.daqTypeEqpInfoQuery(this.cardList[this.activeEqpCard].businessId);
        }).catch(err => {
          this.loading.uploadIsLoading = false;
        });
      }
    },
    uploadFileCheck(file){
      const isLt1G = file.size / 1024 / 1024 /1024< 1
      if(!isLt1G){
        this.$refs.notify.show("暂不允许超过1GB的超大文件上传，请使用网盘存储，URL填入“备注”中。", {timeout: 1000, color: 'red'});
        throw '文件大小超过1G'
      }
    },
    downloadFile(url){
      console.log(url,'---------url---')
      let link = document.createElement('a');
      link.style.display = 'none';
      link.download='';
      link.href = url;
      document.body.appendChild(link);
      link.click();
      //下载完成后
      document.body.removeChild(link);
    },
    urlCheck(){
      let urlRegex = "((http[s]{0,1}|ftp)://[a-zA-Z0-9\\.\\-]+\\.([a-zA-Z]{2,4})(:\\d+)?(/[a-zA-Z0-9\\.\\-~!@#$%^&*+?:_/=<>]*)?)|(www.[a-zA-Z0-9\\.\\-]+\\.([a-zA-Z]{2,4})(:\\d+)?(/[a-zA-Z0-9\\.\\-~!@#$%^&*+?:_/=<>]*)?)"
      let urlReg = new RegExp(urlRegex);
      if (urlReg.test(this.eqpInfo.eqpHostInfoVO.remark)){
        this.remarkUrlChange = this.eqpInfo.eqpHostInfoVO.remark.replaceAll(new RegExp(urlReg,"gm"), function($url){
          return "<a href='" + $url + "' target='_blank'>" + $url + "</a>";
        });
        return (true);
      }else{
        return (false);
      }
    },
    //设备一键导出
    eqpLogReport(){
      this.eqpExport.eqpId = this.cardList[this.activeEqpCard].businessId
      this.eqpExport.daqType = this.cardList[this.activeEqpCard].daqType
      eqpLogReport(this.eqpExport).then(res=>{
        this.downloadFile(res)
      })
    }
  },
  created() {
    this.activeParamInfo = 1;
    if (!this.$route.query.id) {
      this.queryHospCollectCount();
    } else {
      this.queryHospCollectCount(this.$route.query.id);
      if(this.$route.query.businessId&&this.$route.query.businessId!='undefined'){
        this.businessId=this.$route.query.businessId;
      }
      if(this.$route.query.eqpId&&this.$route.query.eqpId!='undefined'){
        this.eqpId=this.$route.query.eqpId;
      }
    }
  }
}
</script>

<style scoped>

.divIcon {
  display: block;
  width: 0.8rem;
  height: 0.8rem;
  background-color: #0057FF;
  margin-right: 0.625rem;
}

.orange_divIcon {
  background-color: #FF9200;
}

.deptName {
  background-color: #F4F4F4;
  color: #000;
  padding: 5px 10px;
  font-size: 0.875rem;
  border-radius: 2px;
  margin-left:5px;
  max-width:48%;
}

.activeColor {
  color: #0057FF;
}

.activeWarningColor {
  color: #FF7E00;
}

.f-s-14 {
  font-size: 0.875rem;
}

.warningIcon {
  background-color: #FF7E00;
  color: #fff;
  padding: 5px 10px;
  border-radius: 2px;
  font-size: 0.75rem;
}

.activeCard {
  background-color: #0057FF;
  color: #fff;
}

.iconStyle {
  width: 2rem;
  height: 2rem;
  margin-right: 0.9rem;
}

.currentNum {
  min-width: 5.5rem;
  padding: 2px 0;
  background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/kk2.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753406061&Signature=tThGVvfO%2BRSOeqwkEa20NGGX%2BDU%3D");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  text-align: center;
  color: #fff;
  font-size:0.8rem;
}

.warningCurrentNum {
  background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/kk.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753406088&Signature=SwIrdSPA4HzXNln2S4gs%2BnQpCU4%3D");
}
</style>
